import { styled } from "goober";
import { useLayoutEffect, useRef, useState } from "react";

const InfoTooltip = styled("div")`
  position: fixed;
  background: var(--text-primary);
  color: var(--text-invert);
  border-radius: 8px;
  padding: 8px 10px;
  pointer-events: none;
  z-index: 10;
  font-size: 10px;
  line-height: 14px;
  white-space: nowrap;
  transform: translateY(-100%);
`;

// Positions against the chart svg's live rect and its own measured width
// (for viewport-edge flipping), which are post-render reads.
type Props = {
  svgRef: React.RefObject<SVGSVGElement | null>;
  anchorLeft: number;
  anchorTop: number;
  children: React.ReactNode;
};

export function AnchoredInfoTooltip({
  svgRef,
  anchorLeft,
  anchorTop,
  children,
}: Props) {
  const selfRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState<{
    left: number;
    top: number;
  } | null>(null);

  useLayoutEffect(() => {
    const svgRect = svgRef.current?.getBoundingClientRect();
    if (!svgRect) return;
    const tooltipWidth = selfRef.current?.offsetWidth ?? 0;
    const baseLeft = svgRect.left + anchorLeft;
    const flipped = baseLeft + tooltipWidth > window.innerWidth - 8;
    setPosition({
      left: flipped ? baseLeft - tooltipWidth - 16 : baseLeft,
      top: svgRect.top + anchorTop,
    });
  }, [svgRef, anchorLeft, anchorTop]);

  return (
    <InfoTooltip
      ref={selfRef}
      style={
        position
          ? { left: position.left, top: position.top }
          : { visibility: "hidden" }
      }
    >
      {children}
    </InfoTooltip>
  );
}
